module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-250.f86efcf8.svg";